import { whiteOrBlackTextColor } from 'helpers/StyleUtils';
import useWebsiteBuilder, { WebsiteBuilder_textExists, WebsiteBuilderContent, WebsiteBuilderStyle } from 'Hooks/useWebsiteBuilder';
import { styx } from 'modules/Utils';
import { CSSProperties } from 'react';

interface TextPreviewContentProps {
    contentIndex: number;
    websiteContent: WebsiteBuilderContent[];
    websiteStyle: WebsiteBuilderStyle;
    style?: CSSProperties;
    onClickContentBlock?: (index: number) => void;
}

const TextPreviewContent = ({
    contentIndex,
    websiteContent: websiteContentProp,
    websiteStyle: websiteStyleProp,
    style: styleProp,
    onClickContentBlock,
}: TextPreviewContentProps) => {
    const {
        websiteContent: websiteContentState,
        websiteStyle: websiteStyleState,
    } = useWebsiteBuilder() as WebsiteBuilder_textExists;

    const websiteContent = websiteContentProp || websiteContentState;
    const websiteStyle = websiteStyleProp || websiteStyleState;
    const contentBackgroundColor = websiteContent[contentIndex].contentBackgroundColor || websiteStyle.backgroundColor;

    const {
        fontFamily,
        textAlign,
        textColor: OLD,
    } = websiteStyle;

    const textContent = websiteContent[contentIndex].textContent;
    const contentTextColor = websiteContent[contentIndex].contentTextColor || whiteOrBlackTextColor(contentBackgroundColor);
    const isTextColorEnabled = websiteContent[contentIndex].isContentTextColorEnabled;

    const textColor = isTextColorEnabled ? contentTextColor : whiteOrBlackTextColor(contentBackgroundColor);

    if (!textContent) {
        return null;
    }

    // NOTE: render()
    return (
        <div
            className="textPreviewContentComponent"
            style={styx(
                sty.textPreviewContentComponent,
                { textAlign },
                styleProp,
            )}
            onClick={() => onClickContentBlock?.(contentIndex)}
        >
            {textContent?.title &&
                <div
                    className="textPreviewContentTitle"
                    style={styx(
                        sty.textPreviewContentTitle,
                        { fontFamily, color: textColor }
                    )}
                >
                    {textContent.title}
                </div>
            }
            {textContent.isSubtitle && textContent.subtitle !== '' &&
                <div
                    className="textPreviewContentSubtitle"
                    style={styx(
                        sty.textPreviewContentSubtitle,
                        { fontFamily, color: textColor }
                    )}
                >
                    {textContent?.subtitle}
                </div>
            }
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    textPreviewContentComponent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        paddingLeft: 16,
        paddingRight: 16,
    },
    textPreviewContentTitle: {
        fontSize: 24,
        width: '100%',
        fontWeight: 500,
    },
    textPreviewContentSubtitle: {
        fontSize: 16,
        width: '100%',
    }
}

export default TextPreviewContent;